import { render, staticRenderFns } from "./user-feedback.vue?vue&type=template&id=6bd6a414&"
import script from "./user-feedback.vue?vue&type=script&lang=js&"
export * from "./user-feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports